import api from "../apiapp";
// import apinew from "../apinew";


const fundService = {
    getFundSearch: async function (model) {
      var filters = '';
      if(model.name !== ""){ filters += '&filter[name]='+model.name; }
      if(model.fundClassId !== null){ filters += '&filter[fundClassId]='+model.fundClassId; }
      const response = await api.request({
          url: 'funds?include=subscriptionTerm,rescueTerm,currency,fundClass&sort=name&page[size]=100&filter[active]=1'+filters,
          method: "GET",
      })
      
      return response.data
    },
    getFundSearchPagination: async function (purl) {
      const response = await api.request({
        url: purl,
        method: "GET",
      })
      
      return response.data
    },
    deleteFund: async function (id) {
      const response = await api.request({
        url: 'funds/'+id,
        method: "DELETE",
      })
      
      return response.data
    },
    setFund: async function (model) {
      const response = await api.request({
        url: 'funds/',
        data: model,
        method: "POST",
      })
      
      return response.data
    },
    putFund: async function (model, id) {
      const response = await api.request({
        url: 'funds/'+id,
        data: model,
        method: "PUT",
      })
      
      return response.data
    },
    getFundOperationSearch: async function (model) {
      var filters = '';
      if(model.dateFrom !== '' && model.dateFrom !== ""){ filters += '&filter[from]='+model.dateFrom; }
      if(model.dateTo !== '' && model.dateTo !== ""){ filters += '&filter[to]='+model.dateTo; }
      if(model.account !== '' && model.account !== null){ filters += '&filter[account]='+model.account; }
      if(model.status !== '' && model.status !== null){ filters += '&filter[state]='+model.status; }
      if(model.operationType !== '' && model.operationType !== null){ filters += '&filter[operationType]='+model.operationType; }
      if(model.acdi !== '' && model.acdi !== null){ filters += '&filter[isAcdi]='+model.acdi; }
      if(model.fund !== '' && model.fund !== null){ filters += '&filter[fundName]='+model.fund; }
      if(model.accountManager !== '' && model.accountManager !== null){ filters += '&filter[portfolioManagerId]='+model.accountManager; }

      const response = await api.request({
        url: 'fund-operations?include=fundOperationMailLogs,accountModel,fundOperationStatus,fund,user,operationLogs,settlementTerm,operationType,currency,operationState,investmentMode,blockedBy&sort=date&page[size]=50'+filters,
        method: "GET",
      })
      
      return response.data
    },
    putFundPaymentStatus: async function (id, status) {
      const response = await api.request({
        url: 'fund-operations/'+id+'/update-payment-status/',
        data: {
          fund_payment_status_id: status
        },
        method: "PUT",
      })
      return response.data
    },
    getFundOperationPaymentSearch: async function (model) {
      var filters = '';
      if(model.dateFrom !== '' && model.dateFrom !== ""){ filters += '&filter[from]='+model.dateFrom; }
      if(model.status !== '' && model.status !== null){ filters += '&filter[state]='+model.status; }
      
      const response = await api.request({
        url: 'fund-operations?include=fundOperationMailLogs,accountModel,fundOperationStatus,fund,user,operationLogs,settlementTerm,operationType,currency,operationState,investmentMode,blockedBy&sort=date&page[size]=50'+filters,
        method: "GET",
      })
      
      return response.data
    },
    postFundOperationNoPayment: async function (model) {
      const response = await api.request({
        url: 'fund-operations/reports/without-payment?include=fundOperationMailLogs,accountModel,fundOperationStatus,fund,user,operationLogs,settlementTerm,operationType,currency,operationState,investmentMode,blockedBy',
        data: model,
        method: "POST",
      })
      
      return response.data
    },
    setFundOperation: async function (model) {
      const response = await api.request({
        url: "fund-operations/",
        data: model,
        method: "POST",
      })
      
      return response.data
    },
    getFundsAutocomplete: async function (personType) {
      let filters = '';
      if(personType === 1){ filters += '&filter[personType]=1'; }      
      if(personType === 2){ filters += '&filter[personType]=2'; }      
      const response = await api.request({
        url: 'funds?sort=name&page[size]=100000&filter[active]=1'+filters+'&include=subscriptionTerm,rescueTerm,currency,fundUnitPriceLogs',
        method: "GET",
      })
      return response.data
    },
    getFundOperationToday: async function () {
      const response = await api.request({
        url: 'fund-operations/reports/today?page[size]=1000&sort=-id&include=fund,user,operationLogs,settlementTerm,operationType,currency,market,segment,priceType,operationState,accountModel,blockedBy,funds,investmentMode',
        method: "GET",
      })
      return response.data
    },
    putFundStatus: async function (id, model) {
      const response = await api.request({
        url: 'fund-operations/'+id+'/change-state',
        data: model,
        method: "PUT",
      })
      return response.data
    },
    putFundOperation: async function (id, model) {
      const response = await api.request({
        url: 'fund-operations/'+id,
        data: model,
        method: "PUT",
      })
      return response.data
    },
    putFundAuthStatus: async function (id, model) {
      const response = await api.request({
        url: 'fund-operations/'+id+'/change-status',
        data: model,
        method: "PUT",
      })
      return response.data
    },
    putFundAuthComments: async function (id, model) {
      const response = await api.request({
        url: 'fund-operations/'+id+'/update-note',
        data: model,
        method: "PUT",
      })
      return response.data
    },
    getFundById: async function (id) {
      const response = await api.request({
        url: 'fund-operations/'+id+'?include=fund,user,operationLogs,settlementTerm,operationType,currency,market,segment,priceType,operationState,accountModel,blockedBy,funds,investmentMode',
        method: "GET",
      })
      return response.data
    },
    getManagementCompanySign: async function (model) {
      const response = await api.request({
        url: 'esco-and-fund-operations/management-company-sign',
        method: "POST",
        data: model,
      })
      return response.data
    },
    getManagementCompanyReject: async function (model) {
      const response = await api.request({
        url: 'esco-and-fund-operations/management-company-reject',
        method: "POST",
        data: model,
      })
      return response.data
    },
    putFundAuthStatusManualApprove: async function (id) {
      const response = await api.request({
        url: 'fund-operations/'+id+'/manual-approve',
        data: {},
        method: "PUT",
      })
      return response.data
    },
    putFundAuthStatusManualReject: async function (id) {
      const response = await api.request({
        url: 'fund-operations/'+id+'/manual-reject',
        data: {},
        method: "PUT",
      })
      return response.data
    },

}
  
export default fundService;
